module.exports = __webpack_public_path__ + "img/mesa_l001b.d0e0e3d0.png";